import { SubscriptionApiResponse } from 'src/services/responseTypes/subscriptionApiResponse';

export const fetchEntitlementUserType = (
  currentActiveSubscriptions: SubscriptionApiResponse
) => {
  let entitlementType = '';

  if (currentActiveSubscriptions) {
    // Pack is Active
    const subscriptionItemPlan = currentActiveSubscriptions?.subscription_plan;
    const isPlanItemSVOD =
      subscriptionItemPlan &&
      (subscriptionItemPlan.tv_show_audio_languages.length === 0 ||
        subscriptionItemPlan.movie_audio_languages.length === 0 ||
        subscriptionItemPlan.channel_audio_languages.length === 0);

    if (isPlanItemSVOD) {
      entitlementType = 'SVOD';
    }
  }
  return entitlementType;
};
